var React = require('react');

function Dash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0.504395L40.3496 0.504391","stroke":"white"}));
}

Dash.defaultProps = {"width":"41","height":"1","viewBox":"0 0 41 1","fill":"none"};

module.exports = Dash;

Dash.default = Dash;
